/**
 * ES Module wrapper for StatsigService
 * Provides ES module exports for React components while the main statsig-init.js
 * remains compatible with AngularJS script loading.
 */

// Access the global StatsigService that's loaded via script tag
const getStatsigService = () => {
  // First check if it's available on window (from script tag loading)
  if (typeof window !== 'undefined' && window.StatsigService) {
    return window.StatsigService;
  }
  
  // Fallback: try to require it (for testing environments)
  try {
    const module = require('../../js/service/statsig-init');
    return module.StatsigService;
  } catch (e) {
    console.warn('[StatsigService] Unable to load StatsigService:', e);
    // Return a stub that safely fails
    return {
      checkGate: () => Promise.resolve(false),
      setUser: () => {},
      updateUser: () => {},
      getEnvironmentTier: () => 'development',
      setAccountGetter: () => {},
      activateContextualGate: () => {},
      deactivateContextualGate: () => {},
      clearContextualGates: () => {},
      getActiveGates: (userGates = []) => userGates
    };
  }
};

export const StatsigService = getStatsigService();
export default StatsigService;
